<template>
  <div style="width: 100vw;height: 100vh;background-color: #f5f7f9;overflow-x: hidden;position: relative">
    <div class="header">
      <div class="header-icon" @click="$router.push('/')"></div>
      <div class="header-title">{{$route.query.subject==='物理'?'物理':$route.query.subject==='化学'?'化学':$route.query.subject==='生物'?'生物':''}}同步实验资源</div>
      <div class="header-pic"
           @click="clickZone">
        <div class="user-card"
             ref="user-card-list"
             v-if="showCard">
          <div class="user-card-pic"></div>
          
            <div style='position: absolute;z-index:999'>
              <div class="user-msg">
                <span style="display: inline-block">{{username}}</span>
                <span style="display: inline-block">{{'ID：'+(account.length>7?account.slice(0,7)+'...':account)}}</span>
              </div>
            </div>
          


          <div class="user-btn-list">
            <div class="user-card-btn"
                 @click="changeRight('toHome')">
              <img class="user-btn-pic"
                   src="http://data.xiyilab.com/web/main/static/home/p__基本资料大icon-拷贝.png">
              <div class="user-btn-text">个人中心</div>
            </div>
            <div class="user-card-btn"
                 @click="changeRight('exit')">
              <img class="user-btn-pic"
                   src="http://data.xiyilab.com/web/main/static/home/安全退出icon.png">
              <div class="user-btn-text"
                   @click="logout=true">安全退出</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <el-dialog :visible="logout"
               width="30%"
               title="警告">
      <span>确认退出吗？当前未保存的操作将全部失效！！！</span>
      <template slot="footer">
        <el-button @click="logout=false">取消</el-button>
        <el-button @click="logOut">确认</el-button>
      </template>
    </el-dialog>
    <div class="info-header">
      <div class="back-btn"
           @click="$router.push({
      path:backPath,
      query:{
        page:$route.query.page,
        selectRule:JSON.stringify($route.query.selectRule),
        subject:$route.query.subject,
        search_word:$route.query.search_word
      }
    })">
        <i class="el-icon-back back-icon"></i>
        <span class="back-text">返回</span>
      </div>
      <div class="short-line"></div>
      <div class="header-text">{{$route.query.name}}</div>
    </div>

    <div class="info-body">

      <div class="info-link-action">
        <div class="info-link-pic">
          
<!--            <vue-plyr>-->
<!--              <video-->
<!--                :controls="false"-->
<!--                :src="appInfo['preview_video_uri']">-->
<!--                <track kind="captions"-->
<!--                       label="English"-->
<!--                       srclang="en"-->
<!--                       default />-->
<!--              </video>-->
<!--            </vue-plyr>-->
            <vue-plyr :options="videoOption">
              <video
                     :controls="false"
                     :src="appInfo['preview_video_uri']||''">
                <track kind="captions"
                       label="Chinese"
                       srclang="en"
                       default />
              </video>
            </vue-plyr>
          

          <div class="count-pic">
            <div class="count-text">练习{{count}}次</div>
          </div>
        </div>

        <div class="info-link-right">
          <div class="info-link-right-title">
            <span class="block"></span>
            <span class="right-title">
              {{$route.query.name.length>15?$route.query.name.slice(0,15)+'...':$route.query.name}}
            </span>
            <div class="collect-btn"
                 @click="collect">
              <div :class="{'love-heart':collectStatus,'white-heart':!collectStatus}">
              </div>

            </div>
          </div>
          <div class="info-link-right-router"
               style="font-size: 0.8em;margin-top:1vw ">
            {{ $route.query.publisher||'人教版' }}>{{ $route.query.subject||'物理' }}>{{ $route.query.grade||'八年级' }}>{{ $route.query.chapter||'第三章' }}
          </div>
          <div class="info-link-right-btn-group">

            <div class="slide-btn" :style="{visibility:user_type==='老师'?'inherit':'hidden'}">
              <div class="btn-text">
                <div class="text-left"
                     @click="silde('right')">
                  {{appMod[0]}}
                </div>
                <div class="text-right"
                     @click="silde('left')">
                  {{appMod[1]}}
                </div>
              </div>
              <div id="btn1"
                   class="white-blank"></div>
            </div>
            <div @click="openApp"
                 class="long-btn">
              <div style="color: white;font-size: 0.7vw;line-height: 2vw;display: flex;flex-wrap: nowrap;justify-content:center ">
                <span class="triangle "></span>
                <span style="display: inline-block">开始实验</span>
              </div>

            </div>
          </div>
          <div class="info-body-text">
            <span style="font-size: 1.2em;">实验简介：</span><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{appInfo['introduction']}}
          </div>
          <div class="btn-group">
            <div class="btn-windows"
                 style="background-color: #6dbd6a">
              <div class="windows-icon windows"></div>
              <div class="btn-group-text">打开Windows</div>
              <div class="download-icon"></div>
            </div>
            <div class="btn-windows"
                 style="background-color: #f7e55d">
              <div class="windows-icon desktop"></div>
              <div class="btn-group-text">打开桌面式VR</div>
              <div class="download-icon"></div>
            </div>
            <div class="btn-windows"
                 style="background-color: #5cb3f5">
              <div class="windows-icon vrsolid"></div>
              <div class="btn-group-text">打开沉浸式VR</div>
              <div class="download-icon"></div>
            </div>
            <div class="btn-windows"
                 style="background-color: #ff7953">
              <div class="windows-icon android"></div>
              <div class="btn-group-text">打开Android</div>
              <div class="download-icon"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-footer"></div>
  </div>
</template>

<script>

import { getToken } from '@/utils/auth'
import Footer from '@/components/Footer'
import { getAppInfo, getAppCount, logApp, collectApp, getAppCollectStatus } from '@/api/app'
import $ from 'jquery'
const subjectSet = {
  physical: {
    color: '#8181ff'
  },
  chemistry: {
    color: '#ffff81'
  },
  biological: {
    color: '#a6bd82'
  }
}
export default {
  name: 'appInfo',
  components: {
    Footer
  },
  layout:'home',
  created () {
      window.addEventListener('storage', event => {
        if(event.key === 'deleteList') {
          // let deleteStr=event.newValue.split(',')
          // console.log(deleteStr)
          // let req=window.indexedDB.open('UnityCache')
          // req.onsuccess=e=>{
          //   let db=e.target.result
          //   let get= db.transaction(["XMLHttpRequest"],'readwrite').objectStore("XMLHttpRequest").getAll()
          //   get.onsuccess=e=>{
          //     console.log(e.target.result)
          //     for(let i=0;i<deleteStr.length;i++){
          //       let del=db.transaction(["XMLHttpRequest"],'readwrite').objectStore("XMLHttpRequest").delete(deleteStr[i])
          //       del.onsuccess=e=>{
          //         console.log('success')
          //       }
          //       del.onerror=e=>{
          //         console.log('error')
          //       }
          //     }
          //   }
          // }
          console.log('12341242')
          console.log(window.indexedDB.deleteDatabase('UnityCache'))
        }
      })
      this.backPath=localStorage.getItem('user_identity')==='普通用户'?'/onlineCustomApp':'/online-app'
      let Agents = ["android", "iphone", "symbianos", "windows phone", "ipad", "ipod"];
      let userAgent = navigator.userAgent.toLowerCase()
      for (let v = 0; v < Agents.length; v++) {
        if (userAgent.indexOf(Agents[v]) >= 0) {
          if (Agents[v] === 'android') {
            this.agent = Agents[v]
          }
          else {
            this.agent = 'iOS'
          }
          break
        }
      }
      if (this.agent !== 'mobile') {
        this.agent = 'desktop'
      }

  },
  mounted () {
    let that=this
    document.onclick = function () {
      that.$nextTick(()=>{
        that.showCard=false
      })
    }

    this.user_type=localStorage.getItem('user_identity')
    this.router = JSON.parse(localStorage.getItem('router'))
    getAppInfo(this.$route.query.id)
      .then(res => {
        if (res.data.length === 0) {
          this.$message.error('当前实验无权查看')
          this.$router.go(-1)
        }
        else {
          if (this.agent === 'desktop') {
            this.appInfo = res.data[0]
          }
          else {
            for (let i = 0; i < res.data.length; i++) {
              if (this.agent === res.data[i].platform) {
                this.appInfo = res.data[i]
                break
              }
            }
          }
        }
      })
      .then(() => {
        getAppCount(this.appInfo.id).then(res => {
          if(res.status==='ok'){
            this.count = res.data['usage_counter']
          }
        })
        getAppCollectStatus(this.appInfo.app_id).then(res => {
          if (res.status === 'ok') {
            this.collectStatus = (res.data['like'] === 1)
          }
          if (res['message'] === '无权访问') {
            this.$message.error('登录信息过期，请重新登陆')
            this.$store.dispatch('User/logout')
            this.logout = false
            localStorage.clear()
            setTimeout(() => {

              if (this.$route.path !== '/') {
                this.$router.push('/')
              }
              else {
                this.$router.go(0);
              }
            }, 500)
          }
        })
      })
    this.username = localStorage.getItem('username')
    this.account = localStorage.getItem('account')
    let token = localStorage.getItem('token')
    this.loginStatus = token ? true : false
    let userdata = {
      email: localStorage.getItem('email'),
      phone: localStorage.getItem('phone'),
      uid: localStorage.getItem('uid'),
      hasPwd: localStorage.getItem('hasPwd'),
      user_type: localStorage.getItem('user_type'),
      leastDate: localStorage.getItem('leastDate'),
      token: localStorage.getItem('token')
    }
    console.log(localStorage.getItem('email'))
    if (token) {
      this.$store.dispatch('User/reLogin', userdata)
    }
  },
  data () {
    return {
      agent: '',
      backPath:'',
      account: '',
      username: '',
      showCard: false,
      logout: false,
      position: 'left',
      appMod: ['学习', '授课'],
      router: [],
      user_type: '',
      collectStatus: false,
      count: 0,
      mode: 0,
      loginStatus: getToken() ? true : false,
      appInfo: '',
      videoOption:{

      }
    }

  },
  methods: {
    openApp () {
      let that = this
      logApp({
        app_platform_id: this.appInfo.id
      }).then(res => {
        console.log(123)
        if (res.status === 'ok') {
          let url=that.$router.resolve({
            path: '/webGL',
            query: {
              name:this.$route.query.name,
              app_uri:that.appInfo['app_uri'],
              platform:'webgl',
              app_platform_id: that.appInfo.id,
              app_id: that.appInfo.app_id,
              mode: this.mode,
              publisher: that.$route.query.publisher,
              grade: that.$route.query.grade,
              subject: that.$route.query.subject,
              chapter: that.$route.query.chapter
            }
          })
          window.open(url.href,'_blank')

          // window.open(routeUrl .href, '_blank');
        }
        else {
          if (res['message'] === '无权访问') {
            this.$message.error('登录信息过期，请重新登陆')
            this.$store.dispatch('User/logout')
            this.logout = false
            localStorage.clear()
            setTimeout(() => {

              if (this.$route.path !== '/') {
                this.$router.push('/')
              }
              else {
                this.$router.go(0);
              }
            }, 500)
          }
          else {
            this.$message.warning('网络出错')
            that.$router.push({
              path: '/webGL/',
              query: {
                url: that.appInfo['app_uri'],
                app_platform_id: that.appInfo.id
              }
            })
          }
        }
      })
    },
    silde (position) {
      if (position === 'left' && this.position === 'left') {
        this.mode = 1
        $('#btn1').animate({ left: "+=3vw" }, 100)
        this.position = 'right'
        setTimeout(() => {
          $('.text-left')[0].style.color = 'black'
          $('.text-right')[0].style.color = 'white'
        }, 100)
      }
      if (position === 'right' && this.position === 'right') {
        this.mode = 0
        $('#btn1').animate({ left: "-=3vw" }, 100)
        this.position = 'left'
        setTimeout(() => {
          $('.text-left')[0].style.color = 'white'
          $('.text-right')[0].style.color = 'black'
        }, 100)

      }
      console.log(this.mode)
    },
    collect () {


        collectApp({
          app_id: this.appInfo.app_id,
          like: this.collectStatus?0:1
        }).then(res => {
          if (res.status === 'ok') {
            this.collectStatus = !this.collectStatus
          }
          else {
            this.$message.error('收藏失败')
          }
        })

    },
    logOut () {
      this.$store.dispatch('User/logout')
      this.logout = false
      localStorage.clear()
      window.close()
      // setTimeout(() => {
      //
      //   if (this.$route.path !== '/') {
      //     this.$router.push('/')
      //   }
      //   else {
      //     this.$router.go(0);
      //   }
      // }, 500)
    },
    clickZone(e){
      e.stopPropagation?e.stopPropagation():e.cancelBubble=true;
      this.showCard=!this.showCard
    },

    changeRight (title) {
      console.log(title)
      if(title==='toHome'){
        this.$router.push('/home')
      }
    },

  }

}
</script>

<style scoped>
.info-header {
  width: 80%;
  height: 3vw;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  margin: 1vw auto;
}
.back-btn {
  height: 2vw;
  line-height: 2vw;
  background-color: #5eb2f7;
  border-radius: 2vw;
  display: flex;
  flex-wrap: nowrap;
  margin: 0.5vw;
  width: 5vw;
  font-size: 0.8vw;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  color: white;
}
.back-icon {
  font-size: 0.8vw;
  margin-top: 0.6vw;
  display: inline-block;
}
.back-text {
  display: inline-block;
  margin-left: 0.5vw;
}
.short-line {
  margin: 1.1vw 0.5vw 1.1vw;
  height: 0.8vw;
  background-color: #a0a0a0;
  width: 1px;
}
.header-text {
  height: 3vw;
  line-height: 3vw;
  font-size: 0.8vw;
  letter-spacing: 1px;
  color: black;
  text-align: center;
}
.info-body {
  width: 85vw;
  left: 7.5vw;
  height: 65vh;
  position: absolute;
  z-index: 999;
}
.info-link-action {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  margin: 0.5vw auto 0;
  height: 100%;
}
.info-link-right {
  width: 25vw;
  font-size: 1vw;
}
.info-link-pic {
  margin-left: 3vw;
  width: 49vw;
  position: relative;
  height: 27.5625vw;
}

.count-pic {
  position: absolute;
  z-index: 10;
  background-image: url("http://data.xiyilab.com/web/main/static/app/多边形1.png");
  min-width: 100px;
  min-height: 37px;
  width: 5.2vw;
  height: 1.9vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  top: 3vw;
  right: -0.3vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.count-text {
  color: white;
  white-space: nowrap;
  margin-bottom: 0.5vw;
}
.info-body-text {
  margin-top: 1vw;
  margin-bottom: 0;
  font-size: 0.85vw;
  line-height: 2vw;
}

.header {
  width: 100%;
  height: 4vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  background-color: white;
}
.header-icon {
  width: 6vw;
  height: 3vw;
  margin-top: 0.5vw;
  margin-left: 3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 2.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.header-pic {
  height: 2vw;
  width: 2vw;
  margin-top: 1vw;
  margin-right: 3vw;
  margin-left: 3vw;
  border-radius: 50%;
  background-image: url("http://data.xiyilab.com/web/main/static/home/小头像.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  position: relative;
}
.user-card {
  position:absolute;
  top: 3vw;
  right: -1vw;
  min-width: 100px;
  max-width: 200px;
  width: 8vw;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.user-card-pic {
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  max-height: 120px;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p__卡片背景.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user-msg {
  display: flex;
  flex-direction: column;
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 0.7vw;
}
.user-card-btn {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  height: 2vw;
  min-height: 25px;
  cursor: pointer;
  width: 100%;
}
.user-btn-pic {
  object-fit: contain;
}
.user-btn-text {
  line-height: 2vw;
  height: 2vw;
  font-size: 0.7vw;
  text-align: center;
  margin-left: 1.5vw;
  white-space: nowrap;
}
.user-card-btn:hover {
  background-color: #f7e35e;
}
.header-title {
  margin: 1vw auto;
  height: 2vw;
  line-height: 2vw;
  font-size: 1.2vw;
  text-align: center;
}
.info-link-right-title {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  height: 2vw;
}
.right-title {
  font-size: 1vw;
  line-height: 2vw;
  height: 2vw;
}
.block {
  width: 4px;
  height: 1vw;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 2vw;
  background-color: #5eb2f7;
}
.collect-btn {
  margin-left: auto;
  width: 1.5vw;
  height: 1.5vw;
  position: relative;
  background-color: rgb(236, 237, 236);
  cursor: pointer;
  z-index: 1;
}
.love-heart {
  top: 0.53vw;
  left: 0.42vw;
  height: 0.6vw;
  width: 0.6vw;
  position: relative;
  transform: rotate(45deg);
  background-color: red;
}
.love-heart:before,
.love-heart:after {
  content: "";
  width: 0.6vw;
  height: 0.6vw;
  /*border: 2px solid black;*/
  border-radius: 50%;
  position: absolute;
  left: -0.3vw;
  background-color: red;
}
.love-heart:after {
  left: 0;
  top: -0.3vw;
}

.white-heart {
  top: 0.53vw;
  left: 0.42vw;
  height: 0.6vw;
  width: 0.6vw;
  position: relative;
  transform: rotate(45deg);
  background-color: white;
}
.white-heart:before,
.white-heart:after {
  content: "";
  width: 0.6vw;
  height: 0.6vw;
  /*border: 2px solid black;*/
  border-radius: 50%;
  position: absolute;
  left: -0.3vw;
  background-color: white;
}
.white-heart:after {
  left: 0;
  top: -0.3vw;
}

.long-btn {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 30%;
  font-size: 0.8em;
  height: 2vw;
  text-align: center;
  background-color: #5eb2f7;
  cursor: pointer;
  border-radius: 1.5vw;
}
.info-link-right-btn-group {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  height: 2vw;
  margin-top: 1vw;
}
.slide-btn {
  margin-right: 2vw;
  width: 6vw;
  height: 2vw;
  border-radius: 1.5vw;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-wrap: nowrap;
  font-size: 0.7vw;
  line-height: 1.5vw;
  cursor: pointer;
  position: relative;
}
.white-blank {
  position: relative;
  width: 3vw;
  height: 2vw;
  border-radius: 1.5vw;
  text-align: center;
  background-color: #7ec75b;
  color: white;
  z-index: 1;
}
.btn-text {
  z-index: 999;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.text-left {
  width: 50%;
  height: 100%;
  text-align: center;
  color: white;
  line-height: 2vw;
}
.text-right {
  width: 50%;
  height: 100%;
  text-align: center;
  color: black;
  line-height: 2vw;
}
.triangle {
  margin: 0.65vw;
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 0.35vw solid transparent;
  border-left: 0.5vw solid white;
  border-bottom: 0.35vw solid transparent;
}
.btn-group {
  margin-top: 2vw;
  width: 100%;
  height: 4vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
}
.btn-windows {
  height: 2vw;
  margin: 0.5vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
}
.windows-icon {
  max-width: 22px;
  max-height: 22px;
  width: 1vw;
  margin: auto 0.5vw auto;
  height: 1vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.windows {
  background-image: url("http://data.xiyilab.com/web/main/static/app/windows.png");
}
.btn-group-text {
  width: 7vw;
  font-size: 0.7vw;
  line-height: 2vw;
  text-align: center;
  color: white;
  height: 2vw;
  white-space: nowrap;
}
.download-icon {
  max-width: 22px;
  max-height: 22px;
  width: 1vw;
  margin: auto 0.5vw auto;
  height: 1vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/app/下载.png");
}
.desktop {
  background-image: url("http://data.xiyilab.com/web/main/static/app/电脑(1).png");
}
.vrsolid {
  background-image: url("http://data.xiyilab.com/web/main/static/app/VRSolid(3D)6(Fil.png");
}
.android {
  background-image: url("http://data.xiyilab.com/web/main/static/app/安卓.png");
}
.info-footer{
  position: fixed;
  background-image: url("http://data.xiyilab.com/web/main/static/app/footer.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100vw;
  height: 15vw;
  bottom: 0vw;
  z-index: 10;
  opacity: 0.2;
}
</style>
